import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';

interface RedemptionInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** The booked visit; the redeem window runs 3h either side of it. */
  scheduledDate?: Date;
}

const WINDOW_MS = 3 * 60 * 60 * 1000;

const formatWindowTime = (d: Date) =>
  `${d.toLocaleDateString('en-US', { weekday: 'short' })}, ${d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}`;

const WindowTile: React.FC<{ label: string; value: string; bg: string }> = ({ label, value, bg }) => (
  <Box p="12px" borderRadius="14px" bg={bg} display="flex" flexDirection="column" gap="4px">
    <Text fontSize="10px" fontWeight={600} letterSpacing="0.08em" textTransform="uppercase" color={ff.body} lineHeight="normal">{label}</Text>
    <Text as="strong" fontSize="16px" lineHeight="normal">{value}</Text>
  </Box>
);

const RedemptionInfoModal: React.FC<RedemptionInfoModalProps> = ({ isOpen, onClose, scheduledDate }) => (
  <ModalShell
    isOpen={isOpen}
    onClose={onClose}
    title={<Text as="span" textStyle="display" fontSize="27px" lineHeight={1.12}>Not quite time yet!</Text>}
    primary={{ label: 'Got it', onClick: onClose, tone: 'ink' }}
  >
    <Text fontSize="15px" lineHeight={1.45} color={ff.body}>
      You can redeem your credit within <Text as="span" fontWeight={600} color={ff.ink}>3 hours</Text> of your scheduled collab time.
    </Text>
    {scheduledDate && (
      <Box display="grid" gridTemplateColumns="repeat(2, minmax(0, 1fr))" gap="8px" mt="14px">
        <WindowTile label="Opens" value={formatWindowTime(new Date(scheduledDate.getTime() - WINDOW_MS))} bg={ff.limeSurface} />
        <WindowTile label="Closes" value={formatWindowTime(new Date(scheduledDate.getTime() + WINDOW_MS))} bg={ff.grey} />
      </Box>
    )}
  </ModalShell>
);

export default RedemptionInfoModal;
